import RosterBackendService from './RosterBackendService';

async function personalizeEvaluatorAccounts (
    siteId: number, purl: string, schoolId?: string, userName?: string
): Promise<boolean> {
    const response = await RosterBackendService.personalizeEvaluatorAccounts({ siteId, purl, schoolId, userName });

    if (response.isOk()) {
        return true;
    }

    return false;
}

export default {
    personalizeEvaluatorAccounts
}
